import { HttpErrorResponse } from '@angular/common/http';

export class MethodNotAllowedError extends Error {
    httpStatus = 405;

    constructor(res: HttpErrorResponse, message?: string) {
        super(message ? message : res.statusText);
        Object.setPrototypeOf(this, MethodNotAllowedError.prototype);
    }
}
